import { Component } from '@angular/core';

@Component({
  selector: 'app-lite-good-section',
  imports: [],
  templateUrl: './lite-good-section.html',
  styleUrl: './lite-good-section.css',
})
export class LiteGoodSection {}
